// Thin wrappers around sonner. Mount <Toaster /> in the app shell for output.
//
// The default export is a drop-in replacement for the old `toastr` module so
// the ~116 existing `toastr.success(...)` call sites only need their import
// swapped to '@/lib/notifications'. toastr's (message, title, options)
// signature maps onto sonner's (message, { description }) — toastr titles
// were bolded above the message, sonner renders message bold with a
// description underneath, so message/title swap roles when a title is given.
import { toast } from 'sonner'

export function showMessage(message) {
  return toast(message)
}

export function successMessage(message) {
  return toast.success(message)
}

export function infoMessage(message) {
  return toast.info(message)
}

export function warningMessage(message) {
  return toast.warning(message)
}

export function errorMessage(message) {
  return toast.error(message)
}

export function handleError(error) {
  if (typeof error === 'string') {
    errorMessage(error)
    return
  }
  const message =
    error?.response?.data?.custom_error_message ||
    error?.message ||
    'Something went wrong'
  errorMessage(message)
}

function withTitle(fn) {
  return (message, title) => (title ? fn(title, { description: message }) : fn(message))
}

export default {
  showMessage,
  successMessage,
  infoMessage,
  warningMessage,
  errorMessage,
  handleError,
  success: withTitle(toast.success),
  info: withTitle(toast.info),
  warning: withTitle(toast.warning),
  error: withTitle(toast.error),
  // toastr.options was assigned globally in main.js; keep the property so
  // legacy configuration writes don't crash while call sites migrate.
  options: {},
}
